import { logService } from '../../helpers/services/statusLog.service';
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const LOG_MODULE = 'statusLog';

// define action 
export const GET_ALL_LOGS = 'getAllLogs';
export const GET_LOGS_WITH_PAGE = 'getLogWithPage';

// define mutation
const REQUEST = "commonRequest";
const GET_ALL_LOGS_REQUEST = "getAllLogs";
const GET_LOGS_WITH_PAGE_REQUEST = "getLogWithPage";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_LOGS]({ commit }, { filter }) {
        logService
            .getAllLogs(filter)
            .then(
                (result) => {
                    commit(GET_ALL_LOGS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_LOGS_WITH_PAGE]({ commit }, { filter }) {
        await logService
            .getAllLogs(filter)
            .then(
                (result) => {
                    commit(GET_LOGS_WITH_PAGE_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },
};

export const mutations = {

    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_LOGS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                type: o.type,
                report: o.new_report,
                menuService: o.menu_service,
                isActive: o.is_active,
                package: o.package,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_LOGS_WITH_PAGE_REQUEST](state, data) {
        let o = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        if (state.list.data == []) {
            state.list.data = o.map((o) => {
                var message = '';
                if(o.type == 0) {
                    message = 'Vehicle Check In'
                }
                else if(o.type == 1) {
                    message = 'Vehicle Check Out'
                }
                else if(o.type == 2) {
                    message = 'Vehicle Pre Inspection Start'
                }
                else if(o.type == 3) {
                    message = 'Vehicle Pre Inspection Finish'
                }
                else if(o.type == 4) {
                    message = o.menu_service.name + " Start"
                }
                else if(o.type == 5) {
                    message = o.menu_service.name + " End"
                }
                else if(o.type == 6) {
                    message = 'Service Advisor Marked Unable Fix'
                }
                else if(o.type == 7) {
                    message = 'Case Billed'
                }
                else if(o.type == 8) {
                    message = 'Service Advisor Marked KIV'
                }
                else if(o.type == 9) {
                    message = 'Report Deleted'
                }
                else if(o.type == 10) {
                    message = 'Report Resume'
                }
                else if(o.type == 11) {
                    message = 'Service Advisor Updated Remark'
                }
                return {
                    uuid: o.uuid,
                    type: o.type,
                    message: message,
                    report: o.new_report,
                    menuService: o.menu_service,
                    isActive: o.is_active,
                    package: o.package,
                    createdBy: o.created_by,
                    createdAt: filtersHelper.getDateFormat(o.created_at),
                    updatedBy: o.updated_by,
                    updatedAt: filtersHelper.getDateFormat(o.updated_at)
                }
            })
        }
        else {
            o.forEach((record) => {
                var message = '';
                if(record.type == 0) {
                    message = 'Vehicle Check In'
                 }
                 else if(record.type == 1) {
                    message = 'Vehicle Check Out'
                 }
                 else if(record.type == 2) {
                    message = 'Vehicle Pre Inspection Start'
                 }
                 else if(record.type == 3) {
                    message = 'Vehicle Pre Inspection Finish'
                 }
                 else if(record.type == 4) {
                    message = record.menu_service.name + " Start"
                 }
                 else if(record.type == 5) {
                    message = record.menu_service.name + " End"
                 }
                 else if(record.type == 6) {
                    message = 'Service Advisor Marked Unable Fix'
                 }
                 else if(record.type == 7) {
                    message = 'Case Billed'
                 }
                 else if(record.type == 8) {
                    message = 'Service Advisor Marked KIV'
                 }
                 else if(record.type == 9) {
                    message = 'Report Deleted'
                 }
                 else if(record.type == 10) {
                    message = 'Report Resume'
                 }
                 else if(record.type == 11) {
                    message = 'Service Advisor Updated Remark'
                 }

                state.list.data.push({
                    uuid: record.uuid,
                    type: record.type,
                    message: message, 
                    report: record.new_report,
                    menuService: record.menu_service,
                    isActive: record.is_active,
                    package: record.package,
                    createdBy: record.created_by,
                    createdAt: filtersHelper.getDateTimeFormat(record.created_at),
                    updatedBy: record.updated_by,
                    updatedAt: filtersHelper.getDateFormat(record.updated_at)
                })
            })
        }
    }
}


